
import { MatIcon } from "@angular/material/icon";
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatChipsModule } from '@angular/material/chips';
import { AuthService } from "../../../services/auth.service";
import { CommonModule } from '@angular/common';
import { S3UploadService, UploadedImage } from '../../../services/uploadImages';
@Component({
  selector: 'app-reservation-details',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatTabsModule,
    MatChipsModule
  ],
  templateUrl: './reservation-details.component.html',
  styleUrl: './reservation-details.component.css'
})
export class ReservationDetailsComponent  implements OnInit{
  accommodations: any[] = [];
   selectedAccommodation: any | null = null;
  availableRooms: any[] = [];
  paymentMethods: any[] = [];
  accommodation_id: any;
  accommodation_name: any;
  room_id: any;
  room_number: any;
  room_type: any;
  check_in: any;
  check_out: any;
  status: any;
  payment_method: any;
  total_value: any;
  guests:any;
  client:any;
  reservation_id:any;
  mode: 'reserva' | 'pago' = 'reserva';
  items:any=['Efectivo','Tarjeta de Crédito/Débito','Nequi','Daviplata','Transferencia Bancaria'];
  isDropdownOpen:boolean=false;
  selectedItem: string | null = null;
  paymentReference: string = '';
  estadias: any[] = [];
  alojamientos: any;
  reservationId: string = '';
  paymentId: string = '';
  reservationData: any = null;
  documentData: any = null;
  selectedPaymentMethod: string | null = null;
  loading: boolean = false;
  error: string = '';
  documentImage: any = null;
  documentImagePreview: string = '';
  loadingDocumentImage: boolean = false;
  errorDocumentImage: string = '';
  isDragOver: boolean = false;
  uploadProgress = {
    show: false,
    percentage: 0,
    uploaded: 0,
    total: 0
  };

 constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ReservationDetailsComponent>,
    private authService: AuthService,
     readonly s3UploadService: S3UploadService,
    @Inject(MAT_DIALOG_DATA) public data: { reservation?: any; accommodations: any[] }
  ) {
    this.accommodations = data.accommodations || [];
  }

selectItem(item: string) {
  this.selectedItem = item;
  this.isDropdownOpen = false;
}

ngOnInit(): void {
 this.loadReservationData(this.data.reservation);
}

public onAddConsumption(){}

public onCheckIn(){

}

 toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

public onCheckOut(){}

public openPayment() {
    this.mode = 'pago';
}

public cancelpayment() {
    this.mode = 'reserva';
}

 private formatDateForInput(dateString: string): string {
    if (!dateString) return '';

    // Convertir de "2025-11-25T00:00:00.000Z" a "2025-11-25"
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  }

 loadReservationData(reservation: any) {
    console.log('RESERVATIOOOOOOOOOOOOOOOON',reservation)
      this.accommodation_id= reservation.accommodation?.id || '';
      this.accommodation_name = reservation.accommodation?.name || 'N/A';
      this.room_id= reservation.room?.id || '';
      this.room_number = reservation.room?.number || 'N/A';
      this.room_type = reservation.room?.type || '';
      this.check_in= this.formatDateForInput(reservation.check_in);
      this.check_out= this.formatDateForInput(reservation.check_out);
      this.status= reservation.status || 'Pendiente';
      this.payment_method= reservation.payment?.payment_method_id || '';
      this.total_value = reservation.payment?.total_value || 0;
      this.reservation_id=reservation.id;
 if (reservation.client) {
      this.client = reservation.client;
    }
if (reservation.guests_detail && Array.isArray(reservation.guests_detail)) {
      this.guests = reservation.guests_detail.map((guest: any) => ({
        id: guest.id || '',
        given_name: guest.given_name || guest.givenName,
        family_name: guest.family_name || guest.familyName,
        document_type: guest.document_type,
        document_number: guest.document_number,
        phone: guest.phone,
        email: guest.email
      }));
    }

  }
handleSubmit() {
throw new Error('Method not implemented.');
}
onCancel() {
this.dialogRef.close();
}

async onFilesSelected(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const files = Array.from(input.files);
      await this.onDocumentFileSelected(files);
      // Limpiar el input para permitir seleccionar el mismo archivo de nuevo
      input.value = '';
    }
  }

  /**
   * Maneja el evento de arrastrar archivos sobre el área
   */
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  /**
   * Maneja cuando se sale del área de arrastre
   */
  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  /**
   * Maneja cuando se sueltan archivos en el área
   */
  async onFilesDrop(event: DragEvent): Promise<void> {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    if (event.dataTransfer?.files) {
      const files = Array.from(event.dataTransfer.files);
      // Filtrar solo archivos de imagen
      const imageFiles = files.filter(
        file => file.type.startsWith('image/') ||
          file.type === 'application/pdf'
      );

      if (imageFiles.length !== files.length) {
        alert('Solo se pueden subir archivos de imagen o PDF.');
      }

      if (imageFiles.length > 0) {
        await this.onDocumentFileSelected(imageFiles);
      }
    }
  }

  async onDocumentFileSelected(files: File[]) {
    this.errorDocumentImage = '';
    this.loadingDocumentImage = true;
    this.documentImage = null;
    this.documentImagePreview = '';
    try {
      for (const file of Array.from(files)) {
        const valid = this.s3UploadService.validateFileReservations(file);
        if (!valid.valid) {
          this.errorDocumentImage = valid.error || 'Archivo no válido';
          this.loadingDocumentImage = false;
          return;
        }
        const preview = await this.s3UploadService.generatePreview(file);
        this.documentImagePreview = preview;
        const resp = await this.s3UploadService.uploadReservationFileToS3(file, this.reservationId);
        console.log('RESPUESTA SUBIDA ARCHIVO',resp);
        if (resp.success && resp.url) {
          this.documentImage = resp.url;
          this.documentData = resp;
        } else {
          this.errorDocumentImage = resp.error || 'Error subiendo imagen';
        }
      }
    } catch (e) {
      this.errorDocumentImage = 'Error procesando imagen';
    }
    this.loadingDocumentImage = false;
  }

}
